/**
 * Quiet Engage card badges for shadow profile discoverability.
 */

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

/**
 * @param {{
 *   hasShadow?: boolean,
 *   hasProposedDiffs?: boolean,
 *   hasConflicts?: boolean,
 * } | null | undefined} summary
 */
function BeerProfileShadowBadges({ summary }) {
  if (!summary?.hasShadow) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        mb: 1,
      }}
      aria-label="Shadow profile status"
    >
      <Chip size="small" variant="outlined" label="Shadow" />
      {summary.hasProposedDiffs ? (
        <Chip size="small" variant="outlined" color="warning" label="Diffs" />
      ) : null}
      {summary.hasConflicts ? (
        <Chip size="small" variant="outlined" color="error" label="Conflicts" />
      ) : null}
    </Box>
  );
}

BeerProfileShadowBadges.propTypes = {
  summary: PropTypes.shape({
    hasShadow: PropTypes.bool,
    hasProposedDiffs: PropTypes.bool,
    hasConflicts: PropTypes.bool,
  }),
};

BeerProfileShadowBadges.defaultProps = {
  summary: null,
};

export default BeerProfileShadowBadges;
